// Custom debounce function
export const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
        const context = this;
        const callback = args[args.length - 1]; // Assuming the last argument is the callback
        const later = () => {
            timeout = null;
            if (typeof callback === 'function') {
                func.apply(context, args).then(callback).catch(callback);
            } else {
                func.apply(context, args);
            }
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}